import {
  normalizeSocialPlatform,
  SOCIAL_PLATFORM_OPTIONS,
} from "./socialPlatforms";
import { stripRichText } from "../../../utils/richText";

export const SOCIAL_FIELD_SUFFIXES = ["platform", "label", "url", "icon"];

function plainSocialValue(value) {
  return stripRichText(value ?? "");
}

export function groupSocialFields(fields) {
  const byIndex = new Map();

  fields.forEach((field) => {
    const match = /^social_(\d+)_(platform|label|url|icon)$/i.exec(field.key || "");
    if (!match) return;
    const index = Number(match[1]);
    const suffix = match[2].toLowerCase();
    if (!byIndex.has(index)) {
      byIndex.set(index, { index, fields: {} });
    }
    byIndex.get(index).fields[suffix] = field;
  });

  return [...byIndex.values()]
    .sort((a, b) => a.index - b.index)
    .map((group) => {
      const platformRaw = plainSocialValue(group.fields.platform?.value ?? "");
      const label = plainSocialValue(group.fields.label?.value ?? "");
      const url = plainSocialValue(group.fields.url?.value ?? "");
      const icon = group.fields.icon?.value ?? "";
      const platform = normalizeSocialPlatform(platformRaw, label) || platformRaw;
      const option = SOCIAL_PLATFORM_OPTIONS.find(
        (item) => item.value === String(platform).toLowerCase()
      );
      return {
        index: group.index,
        platform,
        label: label || option?.label || platform,
        url,
        icon,
        fields: group.fields,
      };
    });
}

export function socialGroupToForm(group) {
  return {
    platform: group?.platform || "twitter",
    label: group?.label || "",
    url: group?.url || "",
    icon: group?.icon || "",
  };
}

export function nextSocialIndex(groups) {
  if (!groups.length) return 0;
  return Math.max(...groups.map((g) => g.index)) + 1;
}

export function socialFieldDefs(index) {
  return [
    {
      key: `social_${index}_platform`,
      label: `Social ${index} Platform`,
      fieldType: "text",
      sortOrder: 100 + index * 4,
      suffix: "platform",
    },
    {
      key: `social_${index}_label`,
      label: `Social ${index} Label`,
      fieldType: "text",
      sortOrder: 101 + index * 4,
      suffix: "label",
    },
    {
      key: `social_${index}_url`,
      label: `Social ${index} URL`,
      fieldType: "url",
      sortOrder: 102 + index * 4,
      suffix: "url",
    },
    {
      key: `social_${index}_icon`,
      label: `Social ${index} Icon`,
      fieldType: "image",
      sortOrder: 103 + index * 4,
      suffix: "icon",
    },
  ];
}
